var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-container',{staticClass:"mt-16"},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('my-setting',{attrs:{"isRegistering":true,"userId":_vm.userId}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }